import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import CategoryContent from './CategoryContent';
import WithConsumer from '../../context/WithConsumer';
import Foot from '../global/Foot';

const Post = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
         
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page c-page-' + post.slug;
	        						    			
		if (context.appError){
		
			return null; 
		
		} else {
				
			return (
						
				<div className={pageClass}>
					
					<div className="c-page__inner">
						<CategoryContent post={post}></CategoryContent>
						<Foot></Foot>		
					</div>
				</div>
					
			)
			
		}

	} else {
		return null;
	}
};
export default WithConsumer(Post);